import { LazyLoadImage } from "react-lazy-load-image-component";
import { GET_BASE_URL } from "../utils/Constants";
import downloadIcon from "..//assets/res/download_icon.svg";

const HorizontalListItem = ({ game, handleItemClick }) => {
  const { name, image_path, description, isForAndroid, isForIos } = game;

  return (
    <div class="inline-block">
      <div class="relative h-[120px] w-[170px] max-w-xs overflow-hidden rounded-lg shadow-md bg-white hover:shadow-xl transition-shadow duration-300 ease-in-out">
        <div onClick={() => handleItemClick(game)}>
          <LazyLoadImage
            className="h-[120px] w-[170px] object-cover object-center rounded-lg"
            src={GET_BASE_URL() + "images/" + image_path}
            alt={name}
          />
        </div>
        <div class="absolute bottom-0 left-0 flex h-[60px] flex flex-row z-10 w-full backdrop-blur-2xl bg-light-blue/30">
          <div className="flex  flex flex-col p-2 w-3/4">
            <p class="text-[16px] medium text-white tracking-wider leading-none h-[4px]">
              {name}
            </p>
            {/* <p class="text-[10px] medium text-white tracking-wider line-clamp-2 mt-[4px]">
              {description}
            </p> */}
          </div>
          <div
            className=" w-1/4 flex flex-col justify-center items-end  w-1/4 mr-2"
            onClick={() => handleItemClick(game)}
          >
            <div
              className="rounded-full bg-dark-blue semiBold  tracking-widest h-[36px] w-[36px]"
              onClick={() => handleItemClick(game)}
            >
              <img src={downloadIcon} className="h-[36px]  p-[8px] w-[36px] " />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HorizontalListItem;
